// extracted by mini-css-extract-plugin
export default {"input":"CustomInput_input__GqmQI","error-message":"CustomInput_error-message__nGxKC"};